export class TimeoutError extends Error {
  constructor(message = 'The request timed out. Check your connection and try again.') {
    super(message)
    this.name = 'TimeoutError'
  }
}

/**
 * Settle-or-timeout guard for network calls that can hang forever on flaky
 * mobile connections (observed: DM thread stuck on "Loading messages…" and
 * sends stuck on "Sending…" with no recovery). The underlying request is NOT
 * aborted — we just stop waiting so the UI can enter an error/retry state.
 */
export function withTimeout<T>(promise: Promise<T>, ms: number, message?: string): Promise<T> {
  return new Promise<T>((resolve, reject) => {
    const timer = setTimeout(() => reject(new TimeoutError(message)), ms)
    promise.then(
      (value) => {
        clearTimeout(timer)
        resolve(value)
      },
      (err) => {
        clearTimeout(timer)
        reject(err)
      },
    )
  })
}
